module.exports = __webpack_public_path__ + "static/img/100761.6560247d.png";